import React, { useState } from 'react';
import { postStudentEnquiry } from '../../services/getAllApi';

const EnquiryButton = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email_address: '',
        contact_number: '',
        course_interested: '',
        city: '',
        agree: false,
        more_info: ''
    });
    const [isHovered, setIsHovered] = useState(false);


    const iconStyle = {
        fontSize: '1.5rem',
        transition: 'transform 0.3s ease, color 0.3s ease',
        transform: isHovered ? 'scale(1.2)' : 'scale(1)',
        color: isHovered ? 'red' : 'black',
        cursor: 'pointer',
    };
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = "/FBS Guaranteed Job MBA 2025.pdf"; // Ensure it's inside 'public' folder
        link.download = "FBS-Brochure.pdf"; // Sets the download filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

  const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });


    if (!formData.first_name || !formData.last_name || !formData.email_address ||
      !formData.contact_number || !formData.course_interested || !formData.city ||
      !formData.agree) {
      setError('Please fill in all fields and agree to the terms.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await postStudentEnquiry(formData);
      if (response.status === 201 || response.status === 200) {
        setSuccessMessage('Your request has been successfully submitted!');
        setFormData({
          first_name: '',
          last_name: '',
          email_address: '',
          contact_number: '',
          course_interested: '',
          city: '',
          more_info: '',
          agree: false
        });
      } else {
        setError(JSON.stringify(response.response.data.message));
      }
    } catch (error) {
      setError('An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };

    return (
        <div>
            <button
                onClick={toggleModal}
                style={{ rotate: '90deg' }}
                className="fixed top-[50%] right-5 bg-orange-500 text-white py-2 px-6 rounded text-xl shadow-lg hover:bg-orange-600 origin-right cursor-pointer z-50 enquiry-button-orange-rotated">
                ENQUIRY
            </button>

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 flex items-center justify-center" style={{ zIndex: 2000 }}>

                    <div className="bg-white w-[90%] sm:w-[500px] p-8 rounded-lg shadow-lg">
                        <div style={{ marginBottom: '4rem', display: 'flex', justifyContent: 'space-between' }}>

                            <h3 className="text-2xl font-bold mb-4 text-orange-500">Enter Details</h3>
                            <i class='bx bx-x icon-close' style={iconStyle}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)} onClick={toggleModal}></i>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="grid gap-[0.6rem] relative bottom-[3rem]">
                                <div className="flex gap-4">
                                    <input
                                        type="text"
                                        name="first_name"
                                        value={formData.first_name}
                                        onChange={handleChange}
                                        placeholder="First Name"
                                        className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                    />
                                    <input
                                        type="text"
                                        name="last_name"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        placeholder="Last Name"
                                        className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                    />
                                </div>
                                <input
                                    type="tel"
                                    name="contact_number"
                                    value={formData.contact_number}
                                    onChange={handleChange}
                                    placeholder="Phone No. +91"
                                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                />
                                <input
                                    type="email"
                                    name="email_address"
                                    value={formData.email_address}
                                    onChange={handleChange}
                                    placeholder="Email"
                                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                />
                                <select
                name="course_interested"
                value={formData.course_interested}
                onChange={handleChange}
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
              >
                <option value="" disabled>Course Interested</option>
                <option value="MBA in Finance">MBA in Finance</option>
              </select>
                                <input
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    placeholder="City"
                                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                />
                                <input
                                    type="text"
                                    name="more_info"
                                    value={formData.more_info}
                                    onChange={handleChange}
                                    placeholder="More Info"
                                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                                />
                                <div className="flex flex-col items-start gap-4">
                                    <p className="text-left text-gray-600 text-[0.6rem]">
                                        By clicking the button below, you agree to receive communications via email/Call/WhatsApp/SMS from FBS-FINXL Business School.
                                    </p>
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            id="agree"
                                            name="agree"
                                            checked={formData.agree}
                                            onChange={handleChange}
                                            className="w-4 h-4 border-2 border-orange-500 rounded bg-white checked:bg-orange-500 checked:border-orange-600 focus:outline-none appearance-none relative before:absolute before:content-['✔'] before:text-white before:text-xs before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:hidden checked:before:block"
                                        />
                                        <label htmlFor="agree" className="text-[0.7rem] text-gray-600 text-left">
                                            I have read and agree to FBS's <a href="/terms" class="text-orange-500 underline">terms & conditions</a>.
                                        </label>
                                    </div>
                                </div>
                                {error && <p className="text-red-500">{error}</p>}
                                {successMessage && <p className="text-green-500">{successMessage}</p>}


                                <div className="downloadB">
                                    <div class="wrapper">
                                        <a onClick={handleDownload} class="c-btn">
                                            <span class="c-btn__label">BROCHURE
                                                <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                                                    </path>
                                                </svg>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-md"
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </form>
                        <button onClick={toggleModal} className="absolute top-0 right-0 mt-2 mr-2 text-xl font-bold text-red-500">X</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EnquiryButton;
